import { render, staticRenderFns } from "./ChooseLangModal.vue?vue&type=template&id=9b33a3aa&scoped=true"
import script from "./ChooseLangModal.vue?vue&type=script&lang=js"
export * from "./ChooseLangModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b33a3aa",
  null
  
)

export default component.exports